var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swmain"},[_c('Top',{on:{"indexInfo":_vm.indexInfo}}),_c('div',{class:_vm.type === 'api' ? 'swas-type' : 'swas'},[_c('b-container',{staticClass:"m-0 p-0",attrs:{"fluid":"fluid"}},[_vm._t("default")],2)],1),_c('Footer',{staticClass:"footer-page"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }